import styled from "styled-components";
import Modal from 'react-bootstrap/Modal';

export const ModalStyled = styled(Modal)`

  backdrop-filter: blur(2px);

  hr {
    margin: 0px;
    padding: 0px;
  }

  .modal-content{
    border-radius: 11px;
    padding: 28px 48px;
  }  

  .modal-header {
    padding: 0;
    border: none;
    justify-content: center;
  }

  .modal-body {
    padding: 0;
    display: flex;
    flex-direction: column;
    p{
      line-height: 16px;
      color: rgba(106, 122, 143, 1);
      text-align: justify;
      letter-spacing: unset;
    }
  }

  .modal-open .modal {
    backdrop-filter: blur(2px);
  }

  .modal-679 {
    min-width: 679px;
  }

  .close {
    color: #bbc8db;
    border: 3px solid #bbc8db;
    border-radius: 50%;
    padding: 0px;
    margin: 0px;
    width: 24px;
    height: 24px;
    position: relative;
    span {
      font-size: 22px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    font-size: 20px;
  }
  .modal-title {
    margin-bottom: 28px;
    font-size: 24px;
    font-weight: 600;
    font-style: normal;
    line-height: 24px;
    color: #475466;
  }
`;

export const ListStyled = styled.li`

  color: #6C757D;
  font-size: 18px;
  font-style: normal;
  font-weight: 325;
  line-height: 24px; 
    
  li {
    list-style-type: disc;
    list-style-position: inside;
    margin-bottom: 20px;
  }
`;

export const ButtonStyled = styled.button`
  color: #4A90E2;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; 
  text-decoration-line: underline;
  width: 69px;
  align-self: center;
  border: none;
  background: none;
`;